import {Avatar, Button, Input, List, Modal, Space, Table, Typography} from "antd";
import {CSVLink} from "react-csv";
import {useRef, useState} from "react";
import {MessageOutlined, SearchOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import Highlighter from "react-highlight-words";


export const PDBList = ({ isLoading, data }) => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [showSentence, setShowSentence] = useState(false)
  const [item, setItem] = useState({})
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Link to={`/PDBs/${text.trim()}`}>
          <Highlighter
            highlightStyle={{
              backgroundColor: '#ffc069',
              padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text}
          />
        </Link>
      ) : (
        <Link to={`/PDBs/${text.trim()}`}>{text}</Link>
      ),
  })
  const columns = [
    {
      key: 'pdb',
      dataIndex: 'pdb',
      title: 'PDB',
      render: text => <Link to={`/PDBs/${text.trim()}`}>{text}</Link>,
      sorter: (a, b) => a.pdb.localeCompare(b.pdb),
      ...getColumnSearchProps('pdb')
    },
    {
      key: 'actions',
      title: 'Actions',
      render: (_, item) => <Button onClick={() => {
        setItem(item)
        setShowSentence(true)
      }} icon={<MessageOutlined />} />
    }
  ]
  return(
    <>
      <Table rowKey={r => r.id} dataSource={data} columns={columns} loading={isLoading} />
      <div style={{ textAlign: 'center' }}>
        <Button type="primary">
          <CSVLink filename="drug_pdb.csv" data={data}>Download CSV</CSVLink>
        </Button>
      </div>
      <Modal
        title={item.title}
        visible={showSentence}
        onOk={() => setShowSentence(false)}
        onCancel={() => setShowSentence(false)}
        centered
        destroyOnClose
        width={1000}
      >
        <Typography.Title level={4}>Abstract: </Typography.Title>
        <p>
          {item.abstract}
        </p>
        {item.doi !== '' ? <>
          <Typography.Title level={4}>DOI: </Typography.Title>
          <p>
            <a target="_blank" href={`https://doi.org/${item.doi}`}>{item.doi}</a>
          </p>
        </> : ''}
      </Modal>
    </>
  )
}